var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.games),function(game){return _c('li',{key:game.id},[_c('a',{attrs:{"href":game.url}},[_vm._v(_vm._s(game.title))]),_c('br'),_c('span',{staticClass:"game_details_oneline"},[_vm._v(_vm._s(game.details))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }